class confirmPassword {
    constructor($compile) {
        "ngInject";
        this.$compile = $compile;
        this.scope = {
            otherModelValue: "=matchPassword"
        };
    }

    link(scope, element) {
        const ngModel = angular.element(element).controller("ngModel");

        ngModel.$validators.matchPassword = (modelValue) => modelValue === scope.otherModelValue;

        scope.$watch("otherModelValue", () => {
            ngModel.$validate();
        });
    }

    static create() {
        return new confirmPassword(...arguments);
    }
}

export {confirmPassword};


// WEBPACK FOOTER //
// ./sources/directives/confirm-password.directive.js